const DbAdapter = require('./db-adapter')

class PaymentAdapter {
  constructor (
    state,
    {
      agaveAdapter,
      pgConnection,
      quickbooksApi,
      logger
    }
  ) {
    const { user = {} } = state
    this.user = user
    this.agaveAdapter = agaveAdapter
    this.quickbooksApi = quickbooksApi
    this.logger = logger
    const username = user.name
    if (pgConnection) {
      this.pgConnection = pgConnection
      this.dbAdapter = new DbAdapter(this.pgConnection, username)
    }
  }

  getOrderTransaction (orderId, { useFin = false } = {}) {
    if (this.dbAdapter) {
      return this.dbAdapter.getOrderTransactions(orderId, { useFin })
    }
    return this.agaveAdapter.get('finances/payment/get_order_transaction', { orderId })
  }

  async createInvoicePayment ({
    quickbooksLocation,
    qboInvoice,
    privateNote,
    paymentAmount
  }) {
    const { quickbooksInterface } = this.quickbooksApi

    const {
      paystackDepositAccountId
    } = quickbooksInterface.accountIds[quickbooksLocation.company_code]

    // get quickbooks customer
    const { Customer: qboCustomer } = await quickbooksInterface.get(
      quickbooksLocation.company_code,
      `/customer/${quickbooksLocation.quickbooks_customer_id}?minorversion=${quickbooksInterface.apiVersion}`
    )

    const { Account: depositAccount } = await quickbooksInterface.get(
      quickbooksLocation.company_code,
      `/account/${paystackDepositAccountId}?minorversion=${quickbooksInterface.apiVersion}`
    )

    // create payment
    const paymentData = {
      TotalAmt: paymentAmount,
      CustomerRef: {
        value: qboCustomer.Id,
        name: qboCustomer.DisplayName
      }
    }
    const { Payment } = await quickbooksInterface.post(
      quickbooksLocation.company_code,
      `payment?minorversion=${quickbooksInterface.apiVersion}`,
      paymentData
    )

    // update payment and link Deposit to Payment with totalAmount
    const transformedData = {
      Id: Payment.Id,
      TotalAmt: Payment.TotalAmt,
      CurrencyRef: Payment.CurrencyRef,
      SyncToken: Payment.SyncToken,
      CustomerRef: Payment.CustomerRef,
      Line: [{
        Amount: Payment.UnappliedAmt,
        LinkedTxn: [{
          TxnId: qboInvoice.Id,
          TxnType: 'Invoice'
        }]
      }],
      DepositToAccountRef: {
        value: depositAccount.Id,
        name: depositAccount.Name
      },
      PrivateNote: privateNote
    }

    const { Payment: finalPayment } = await quickbooksInterface.post(
      quickbooksLocation.company_code,
      `payment?minorversion=${quickbooksInterface.apiVersion}`,
      transformedData
    )

    return {
      payment: finalPayment
    }
  }
}

module.exports = PaymentAdapter
